import { z } from "zod"

const envSchema = z.object({
	VITE_PUBLIC_SERVICE_BACKEND_API_URL: z.url(),
	VITE_PUBLIC_SERVICE_SOCIAL_API_URL: z.url(),
	VITE_PUBLIC_POSTHOG_KEY: z.string().min(1),
	VITE_PUBLIC_POSTHOG_HOST: z.url(),
	VITE_PUBLIC_TG_BOT_USERNAME: z.string().min(1).optional(),
	VITE_PUBLIC_CLOUDPAYMENTS_PUBLIC_ID: z.string().min(1).optional(),
	VITE_PUBLIC_APP_VERSION: z.string().min(1).optional(),
	VITE_PUBLIC_GOOGLE_WEB_CLIENT_ID: z.string().min(1).optional(),
})

export const env = envSchema.parse({
	VITE_PUBLIC_SERVICE_BACKEND_API_URL: import.meta.env
		.VITE_PUBLIC_SERVICE_BACKEND_API_URL,
	VITE_PUBLIC_SERVICE_SOCIAL_API_URL: import.meta.env
		.VITE_PUBLIC_SERVICE_SOCIAL_API_URL,
	VITE_PUBLIC_POSTHOG_KEY: import.meta.env.VITE_PUBLIC_POSTHOG_KEY,
	VITE_PUBLIC_POSTHOG_HOST: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
	VITE_PUBLIC_TG_BOT_USERNAME:
		import.meta.env.VITE_PUBLIC_TG_BOT_USERNAME || undefined,
	VITE_PUBLIC_CLOUDPAYMENTS_PUBLIC_ID:
		import.meta.env.VITE_PUBLIC_CLOUDPAYMENTS_PUBLIC_ID || undefined,
	VITE_PUBLIC_APP_VERSION: import.meta.env.VITE_PUBLIC_APP_VERSION || undefined,
	VITE_PUBLIC_GOOGLE_WEB_CLIENT_ID:
		import.meta.env.VITE_PUBLIC_GOOGLE_WEB_CLIENT_ID || undefined,
})

export const DEVTOOLS_ENABLED =
	import.meta.env.VITE_PUBLIC_DEVTOOLS_ENABLED === "true"
